export const getEnv = () => import.meta.env;
